import { OrdPdtModel } from "@app/models/shoppingmall/order-pdt.model";
import { pdtWishListFeatureKey } from "@app/reducers/shoppingmall/product-wishlist.reducer";
import { createFeatureSelector, createSelector } from "@ngrx/store";

export interface PdtWishListState {
    total: number;
    items: OrdPdtModel[];
    msg: string;
    msgDeleteWishList: Map<String, String>;
    productWishYN: Map<string, string>
}

export const getPdtWishListState = createFeatureSelector<PdtWishListState>(pdtWishListFeatureKey);

export const getPdtWishList = createSelector(
    getPdtWishListState,
    (state: PdtWishListState) => state.items
);

export const getTotalPdtWishList = createSelector(
    getPdtWishListState,
    (state: PdtWishListState) => state.total
);

export const savePdtWishList = createSelector(
    getPdtWishListState,
    (state: PdtWishListState) => state.msg
);

export const delPdtWishList = createSelector(
    getPdtWishListState,
    (state: PdtWishListState) => state.msg
);

export const getMsgDeleteProductWishListResult = createSelector(
    getPdtWishListState,
    (state: PdtWishListState) => state.msgDeleteWishList
);

export const getWishlist = createSelector(
    getPdtWishListState,
    (state: PdtWishListState) => state.productWishYN
);


